import React from 'react';
import { AddButton, AppContent, Link } from '@common/components';
import { StaffingTemplatesTable } from './staffing-templates-table';
import { useSetBreadcrumbs } from 'works/legacy/lib/client-store';
import { ORGANIZATION_ADMIN_MENU } from 'works/pages/organization/admin-settings/organization-admin-vertical-nav-menu';
import { buildDialogUrl } from '@common/services/dialogs-service';

export function StaffingTemplatesPage() {
  useSetBreadcrumbs([
    {
      name: 'Admin',
      path: '/works/admin',
    },
    {
      name: 'Templates',
      path: '/works/admin/templates',
    },
    {
      name: ORGANIZATION_ADMIN_MENU.TEMPLATES__STAFFING_REQUEST.LABEL,
      path: ORGANIZATION_ADMIN_MENU.TEMPLATES__STAFFING_REQUEST.ROUTE,
    },
  ]);

  const createStaffingRequestTemplateDrawerUrl = buildDialogUrl(
    'staffing-request-template-drawer'
  );

  return (
    <>
      <AppContent className="staffing-templates-page">
        <div className="add-template">
          <Link to={createStaffingRequestTemplateDrawerUrl}>
            <AddButton>Template</AddButton>
          </Link>
        </div>
        <StaffingTemplatesTable />
      </AppContent>
      <style jsx>{`
        :global(.staffing-templates-page .add-template) {
          display: flex;
          justify-content: flex-end;
        }
      `}</style>
    </>
  );
}
